import React from 'react';

export default function Impressum() {
  return (
    <div className="min-h-screen py-20 px-4 bg-background">
      <div className="max-w-3xl mx-auto bg-white p-10 rounded-xl border border-border shadow-sm">
        <h1 className="text-4xl font-bold text-primary mb-8 border-b border-border pb-4">Impressum & Kontakt</h1>
        <div className="space-y-6 text-primary">
          <section>
            <h2 className="text-xl font-bold mb-2">Angaben gemäß § 5 TMG</h2>
            <p className="text-muted-foreground">
              ENVISU GmbH<br />
              Dankwartsgrube 51<br />
              23552 Lübeck
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-bold mb-2">Vertreten durch:</h2>
            <p className="text-muted-foreground">Geschäftsführer: Bernd Spautz</p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-2">Registereintrag:</h2>
            <p className="text-muted-foreground">
              Eintragung im Handelsregister.<br />
              Registergericht: Amtsgericht Lübeck (Schleswig-Holstein)<br />
              Registernummer: HRB 27496 HL
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-2">Kontakt</h2>
            <p className="text-muted-foreground">
              E-Mail: <a href="mailto:kontakt@envisu-gmbh.com" className="text-accent hover:underline">kontakt@envisu-gmbh.com</a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-2">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <p className="text-muted-foreground">
              Bernd Spautz<br />
              Dankwartsgrube 51<br />
              23552 Lübeck
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}